import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { SwipeNavigationService } from './swipe-navigation.service';
import { SwipeViewManager } from './swipe-view-manager';
import { fromEvent, merge, Observable } from 'rxjs';
import { takeUntil, map, switchMap, tap } from 'rxjs/operators';
import { rxState } from '@rx-angular/state';


@Directive({
  selector: '[libSwipeNavigate]',
  standalone: true,
})
export class SwipeNavigateDirective implements OnInit {
  
  public state = rxState<{ gestureStream: void }>();

  private manager!: SwipeViewManager;
  // private mouseSub?: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private swipeService: SwipeNavigationService,
  ) {}

  ngOnInit() {
    this.manager = new SwipeViewManager(this.renderer, this.el.nativeElement);

    this.state.connect('gestureStream', this.setupGestureStream());
  }

  private setupGestureStream(): Observable<void> {
    const mouseDown$ = fromEvent<MouseEvent>(this.el.nativeElement, 'mousedown').pipe(
      map(e => ({ x: e.clientX, y: e.clientY, time: performance.now(), type: 'mouse' as const }))
    );

    const touchStart$ = fromEvent<TouchEvent>(this.el.nativeElement, 'touchstart').pipe(
      map(e => ({
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
        time: performance.now(),
        type: 'touch' as const
      }))
    );

    const gestureStart$ = merge(mouseDown$, touchStart$);

    return gestureStart$.pipe(
      switchMap(start => {
        const move$ =
          start.type === 'mouse'
            ? fromEvent<MouseEvent>(document, 'mousemove').pipe(map(e => ({ x: e.clientX, y: e.clientY })))
            : fromEvent<TouchEvent>(document, 'touchmove').pipe(
                map(e => ({ x: e.touches[0].clientX, y: e.touches[0].clientY }))
              );

        const end$ =
          start.type === 'mouse'
            ? fromEvent<MouseEvent>(document, 'mouseup').pipe(map(e => ({ x: e.clientX })))
            : fromEvent<TouchEvent>(document, 'touchend').pipe(
                map(e => ({ x: e.changedTouches[0].clientX }))
              );

        let directionLocked: 'horizontal' | 'vertical' | null = null;
        const startX = start.x;
        const startY = start.y;
        const startTime = start.time;

        return move$.pipe(
          tap(({ x, y }) => {
            const deltaX = x - startX;
            const deltaY = y - startY;

            directionLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
            
            // console.log('SwipeNavigateDirective MOVE directionLocked ', directionLocked);

            // if (!directionLocked) {
            //   directionLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
            // }

            if (directionLocked === 'horizontal') {
              this.manager.translate(deltaX);
            }
          }),
          takeUntil(
            end$.pipe(
              tap(({ x }) => {
                const selection = window.getSelection();
                const hasSelectedText = selection ? selection?.toString().trim().length > 0 : false;
                const deltaX = x - startX;
                const duration = performance.now() - startTime;
                const velocity = deltaX / duration;
                const threshold = window.innerWidth / 3;
                const velocityThreshold = 0.5;
                const shouldNavigate =
                  (Math.abs(deltaX) > threshold || Math.abs(velocity) > velocityThreshold) && !hasSelectedText;

                if (shouldNavigate) {
                  const direction = deltaX > 0 ? 'right' : 'left';
                  this.manager.animateOut(direction);
                  this.swipeService.setSwipe(direction);
                } else {
                  this.manager.reset();
                }
              })
            )
          ),
          map(() => void 0)
        );
      })
    );
  }

}